import { useState, useCallback } from 'react';
import * as zionAreaManagementAction from "../redux/store-sarang/zion-area/zion-area-management.store";

export const useLookupZionArea = () => {
    const [zionArea, setZionArea] = useState([]);

    const getLookupZionArea = useCallback(async (departmentId) => {
        try {
            const res = await zionAreaManagementAction.GetLookupZionArea(departmentId);
            if (res && res.content) {
                setZionArea(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { zionArea, getLookupZionArea };
};
